/**
 * Root Cause Analysis Tab (Step 2) for NCR Edit
 */

import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Label } from '../../components/ui/label';
import { Textarea } from '../../components/ui/textarea';
import { Save, Send } from 'lucide-react';
import { NCREditFormData } from './types';

interface Step2TabProps {
  formData: NCREditFormData;
  canEdit: boolean;
  saving: boolean;
  onUpdateFormData: (field: string, value: unknown) => void;
  onSave: () => void;
  onSubmitRCA: () => void;
}

export function RootCauseTab({
  formData,
  canEdit,
  saving,
  onUpdateFormData,
  onSave,
  onSubmitRCA,
}: Step2TabProps) {
  return (
      <Card>
        <CardHeader>
          <CardTitle>Root Cause Analysis (Supplier Only)</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div>
              <Label>Immediate Containment Action *</Label>
              <Textarea
                value={formData.immediate_corrective_action || ''}
                onChange={(e) => onUpdateFormData('immediate_corrective_action', e.target.value)}
                disabled={!canEdit}
                rows={3}
              />
            </div>

            <div>
              <Label>Supplier Disposition Instructions</Label>
              <Textarea
                value={formData.disposition_instructions || ''}
                onChange={(e) => onUpdateFormData('disposition_instructions', e.target.value)}
                disabled={!canEdit}
                rows={2}
                maxLength={500}
              />
            </div>

            {[1, 2, 3, 4, 5].map((num) => (
              <div key={num}>
                <Label>Why {num}? *</Label>
                <Textarea
                  value={(formData[`why_${num}`] as string) || ''}
                  onChange={(e) => onUpdateFormData(`why_${num}`, e.target.value)}
                  disabled={!canEdit}
                  rows={2}
                  maxLength={500}
                />
              </div>
            ))}

            <div>
              <Label>Selected Root Cause *</Label>
              <Textarea
                value={formData.selected_root_cause || ''}
                onChange={(e) => onUpdateFormData('selected_root_cause', e.target.value)}
                disabled={!canEdit}
                rows={3}
                maxLength={500}
              />
            </div>

            {canEdit && (
              <div className="flex gap-2">
                <Button onClick={onSave} disabled={saving} variant="outline">
                  <Save className="h-4 w-4 mr-2" />
                  Save
                </Button>
                <Button onClick={onSubmitRCA} disabled={saving}>
                  <Send className="h-4 w-4 mr-2" />
                  Submit RCA
                </Button>
              </div>
            )}
          </div>
        </CardContent>
      </Card>
  );
}
